import {
  LayoutDashboard,
  Wallet,
  FileText,
  Building2,
  History,
  CreditCard,
  Headphones,
  BarChart3,
  Users,
  HelpCircle,
  Link2,
  Monitor,
  Target,
  Megaphone,
  Calendar,
  PieChart,
  TrendingUp,
  Settings,
  Activity,
  Briefcase,
  Sliders,
  Layers,
  ShieldAlert,
  Copy,
  UserCheck,
  LineChart,
} from 'lucide-react';
import {
  ADMIN_ROUTES,
  IB_ROUTES,
  USER_ROUTES,
  PAMM_ROUTES,
  MAM_ROUTES,
} from './routeConstants';

export interface MenuItem {
  name: string;
  href: string;
  icon: any;
  children?: MenuItem[];
}

export const USER_DASHBOARD_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    href: USER_ROUTES.USER_DASHBOARD,
    icon: LayoutDashboard,
  },
  { name: 'My Wallet', href: USER_ROUTES.USER_WALLET, icon: Wallet },
  { name: 'KYC Documents', href: USER_ROUTES.USER_KYC, icon: FileText },
  {
    name: 'Accounts',
    href: USER_ROUTES.USER_ACCOUNTS,
    icon: Building2,
    children: [
      {
        name: 'Demo Accounts',
        href: USER_ROUTES.USER_ACCOUNT_DEMO,
        icon: Building2,
      },
      {
        name: 'Live Accounts',
        href: USER_ROUTES.USER_ACCOUNT_LIVE,
        icon: Building2,
      },
      {
        name: 'Leverage History',
        href: USER_ROUTES.USER_ACCOUNT_LEVERAGE_HISTORY,
        icon: History,
      },
      {
        name: 'My Trades',
        href: USER_ROUTES.USER_ACCOUNT_MY_TRADES,
        icon: BarChart3,
      },
    ],
  },
  {
    name: 'Order History',
    href: USER_ROUTES.USER_ORDER_HISTORY,
    icon: History,
  },
  {
    name: 'Payments',
    href: USER_ROUTES.USER_PAYMENTS,
    icon: CreditCard,
    children: [
      { name: 'Deposit', href: USER_ROUTES.USER_DEPOSIT, icon: CreditCard },
      {
        name: 'Withdrawal',
        href: USER_ROUTES.USER_WITHDRAWAL,
        icon: CreditCard,
      },
      { name: 'Transfer', href: USER_ROUTES.USER_TRANSFER, icon: CreditCard },
    ],
  },
  { name: 'Analytics', href: USER_ROUTES.USER_ANALYTICS, icon: BarChart3 },
  {
    name: 'PAMM Management',
    href: PAMM_ROUTES.PAMM_DASHBOARD,
    icon: Building2,
    children: [
      {
        name: 'Dashboard',
        href: PAMM_ROUTES.PAMM_DASHBOARD,
        icon: LayoutDashboard,
      },
      {
        name: 'Money Manager',
        href: PAMM_ROUTES.PAMM_FUND_MANAGEMENT,
        icon: Users,
      },
      {
        name: 'PAMM List',
        href: PAMM_ROUTES.PAMM_INVESTMENT_REQUESTS,
        icon: Briefcase,
      },
      {
        name: 'Investments',
        href: PAMM_ROUTES.PAMM_DEPOSITS,
        icon: TrendingUp,
      },
      {
        name: 'PAMM Withdrawal',
        href: PAMM_ROUTES.PAMM_WITHDRAWALS,
        icon: CreditCard,
      },
    ],
  },
  {
    name: 'MAM',
    href: MAM_ROUTES.MAM_DASHBOARD,
    icon: Layers,
    children: [
      {
        name: 'Dashboard',
        href: MAM_ROUTES.MAM_DASHBOARD,
        icon: LayoutDashboard,
      },
      {
        name: 'Managers',
        href: MAM_ROUTES.MAM_MANAGERS,
        icon: Users,
      },
      {
        name: 'Client Accounts',
        href: MAM_ROUTES.MAM_CLIENT_ACCOUNTS,
        icon: Building2,
      },
      {
        name: 'Allocation',
        href: MAM_ROUTES.MAM_ALLOCATION,
        icon: Sliders,
      },
      {
        name: 'Trades',
        href: MAM_ROUTES.MAM_TRADES,
        icon: Activity,
      },
    ],
  },
  {
    name: 'Copy Trading',
    href: USER_ROUTES.USER_COPY_TRADING_DASHBOARD,
    icon: Copy,
    children: [
      {
        name: 'Dashboard',
        href: USER_ROUTES.USER_COPY_TRADING_DASHBOARD,
        icon: LayoutDashboard,
      },
      {
        name: 'Marketplace',
        href: USER_ROUTES.USER_COPY_TRADING_MARKETPLACE,
        icon: Briefcase,
      },
      {
        name: 'My Copy Trades',
        href: USER_ROUTES.USER_COPY_TRADING_ACTIVE,
        icon: Copy,
      },
      {
        name: 'Live Copied Trades',
        href: USER_ROUTES.USER_COPY_TRADING_LIVE_TRADES,
        icon: Activity,
      },
      {
        name: 'Trade History',
        href: USER_ROUTES.USER_COPY_TRADING_HISTORY,
        icon: History,
      },
      {
        name: 'Risk Management',
        href: USER_ROUTES.USER_COPY_TRADING_RISK,
        icon: ShieldAlert,
      },
      {
        name: 'Provider Dashboard',
        href: USER_ROUTES.USER_COPY_TRADING_PROVIDER_DASHBOARD,
        icon: UserCheck,
      },
    ],
  },
  {
    name: 'IB Accounts',
    href: USER_ROUTES.USER_IB_ACCOUNTS,
    icon: Users,
  },
  { name: 'Supports', href: USER_ROUTES.USER_SUPPORTS, icon: Headphones },
  { name: 'FAQ', href: USER_ROUTES.USER_FAQ, icon: HelpCircle },
  { name: 'Quick Links', href: USER_ROUTES.USER_QUICK_LINKS, icon: Link2 },
  { name: 'Web Terminal', href: USER_ROUTES.USER_WEB_TERMINAL, icon: Monitor },
  {
    name: 'Economic Calendar',
    href: USER_ROUTES.USER_ECONOMIC_CALENDAR,
    icon: Calendar,
  },
];

export const IB_DASHBOARD_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    href: IB_ROUTES.USER_IB_DASHBOARD,
    icon: LayoutDashboard,
  },
  {
    name: 'IB List',
    href: IB_ROUTES.USER_IB_LIST,
    icon: Users,
  },
  {
    name: 'Clients',
    href: IB_ROUTES.USER_IB_CLIENTS,
    icon: Users,
  },
  {
    name: 'Commissions',
    href: IB_ROUTES.USER_IB_COMMISSIONS,
    icon: CreditCard,
  },
  {
    name: 'Wallet',
    href: IB_ROUTES.USER_IB_WALLET,
    icon: Wallet,
  },
  {
    name: 'Rebates',
    href: IB_ROUTES.USER_IB_REBATES,
    icon: CreditCard,
  },
  {
    name: 'Reports',
    href: IB_ROUTES.USER_IB_REPORTS,
    icon: BarChart3,
  },
  {
    name: 'Marketing Tools',
    href: IB_ROUTES.USER_IB_MARKETING_TOOLS,
    icon: Megaphone,
  },
  {
    name: 'KYC',
    href: IB_ROUTES.USER_IB_KYC,
    icon: FileText,
  },
  {
    name: 'Settings',
    href: IB_ROUTES.USER_IB_SETTINGS,
    icon: HelpCircle,
  },
];
export const ADMIN_DASHBOARD_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    href: ADMIN_ROUTES.ADMIN_DASHBOARD,
    icon: LayoutDashboard,
  },
  { name: 'Leads', href: ADMIN_ROUTES.ADMIN_LEADS, icon: Target },
  { name: 'Clients', href: ADMIN_ROUTES.ADMIN_CLIENTS, icon: Users },
  { name: 'Accounts', href: ADMIN_ROUTES.ADMIN_ACCOUNTS, icon: Building2 },
  { name: 'Trades', href: ADMIN_ROUTES.ADMIN_TRADES, icon: BarChart3 },
  { name: 'Payments', href: ADMIN_ROUTES.ADMIN_PAYMENTS, icon: CreditCard },
  { name: 'Supports', href: ADMIN_ROUTES.ADMIN_SUPPORTS, icon: Headphones },
  {
    name: 'IB Marketing',
    href: ADMIN_ROUTES.ADMIN_IB_MARKETING,
    icon: Megaphone,
  },
  {
    name: 'Economic calendar',
    href: ADMIN_ROUTES.ADMIN_ECONOMIC_CALENDAR,
    icon: Calendar,
  },
  {
    name: 'Trading Services',
    href: ADMIN_ROUTES.ADMIN_TRADING_SERVICES_OVERVIEW,
    icon: TrendingUp,
    children: [
      {
        name: 'Copy Trading',
        href: ADMIN_ROUTES.ADMIN_COPY_TRADING_DASHBOARD,
        icon: Copy,
        children: [
          {
            name: 'Dashboard',
            href: ADMIN_ROUTES.ADMIN_COPY_TRADING_DASHBOARD,
            icon: LayoutDashboard,
          },
          {
            name: 'Providers',
            href: ADMIN_ROUTES.ADMIN_COPY_TRADING_MANAGERS,
            icon: Users,
          },
          {
            name: 'Followers',
            href: ADMIN_ROUTES.ADMIN_COPY_TRADING_FOLLOWERS,
            icon: UserCheck,
          },
          {
            name: 'Marketplace',
            href: ADMIN_ROUTES.ADMIN_COPY_TRADING_STRATEGIES,
            icon: LineChart,
          },
          {
            name: 'Subscriptions',
            href: ADMIN_ROUTES.ADMIN_COPY_TRADING_PERFORMANCE,
            icon: Activity,
          },
          {
            name: 'Trade Monitor',
            href: ADMIN_ROUTES.ADMIN_COPY_TRADING_TRADES,
            icon: Monitor,
          },
          {
            name: 'Performance',
            href: ADMIN_ROUTES.ADMIN_TRADING_PERFORMANCE,
            icon: BarChart3,
          },
          {
            name: 'Reports',
            href: ADMIN_ROUTES.ADMIN_TRADING_REPORTS,
            icon: FileText,
          },
          {
            name: 'Logs',
            href: ADMIN_ROUTES.ADMIN_AUDIT_LOGS,
            icon: History,
          },
        ],
      },
      {
        name: 'PAMM',
        href: ADMIN_ROUTES.ADMIN_PAMM_DASHBOARD,
        icon: PieChart,
        children: [
          {
            name: 'Dashboard',
            href: ADMIN_ROUTES.ADMIN_PAMM_DASHBOARD,
            icon: LayoutDashboard,
          },
          {
            name: 'Funds',
            href: ADMIN_ROUTES.ADMIN_PAMM_STRATEGIES,
            icon: Building2,
          },
          {
            name: 'Fund Managers',
            href: ADMIN_ROUTES.ADMIN_PAMM_ACCOUNTS,
            icon: Users,
          },
          {
            name: 'Investors',
            href: ADMIN_ROUTES.ADMIN_PAMM_INVESTORS,
            icon: UserCheck,
          },
          {
            name: 'Deposits',
            href: ADMIN_ROUTES.ADMIN_PAMM_ALLOCATIONS,
            icon: CreditCard,
          },
          {
            name: 'Withdrawals',
            href: ADMIN_ROUTES.ADMIN_PAMM_COMMISSIONS,
            icon: CreditCard,
          },
          {
            name: 'Profit Allocation',
            href: ADMIN_ROUTES.ADMIN_PAMM_PERFORMANCE,
            icon: TrendingUp,
          },
          {
            name: 'Fee Management',
            href: ADMIN_ROUTES.ADMIN_TRADING_FEES,
            icon: CreditCard,
          },
          {
            name: 'Performance',
            href: ADMIN_ROUTES.ADMIN_TRADING_PERFORMANCE,
            icon: BarChart3,
          },
          {
            name: 'Reports',
            href: ADMIN_ROUTES.ADMIN_TRADING_REPORTS,
            icon: FileText,
          },
          {
            name: 'Audit Logs',
            href: ADMIN_ROUTES.ADMIN_AUDIT_LOGS,
            icon: History,
          },
        ],
      },
      {
        name: 'MAM',
        href: ADMIN_ROUTES.ADMIN_MAM_DASHBOARD,
        icon: Activity,
        children: [
          {
            name: 'Dashboard',
            href: ADMIN_ROUTES.ADMIN_MAM_DASHBOARD,
            icon: LayoutDashboard,
          },
          {
            name: 'Groups',
            href: ADMIN_ROUTES.ADMIN_MAM_ACCOUNTS,
            icon: Building2,
          },
          {
            name: 'Masters',
            href: ADMIN_ROUTES.ADMIN_MAM_MANAGERS,
            icon: Users,
          },
          {
            name: 'Followers',
            href: ADMIN_ROUTES.ADMIN_MAM_INVESTORS,
            icon: UserCheck,
          },
          {
            name: 'Allocation Rules',
            href: ADMIN_ROUTES.ADMIN_MAM_ALLOCATIONS,
            icon: PieChart,
          },
          {
            name: 'Trade Monitor',
            href: ADMIN_ROUTES.ADMIN_MAM_TRADES,
            icon: Monitor,
          },
          {
            name: 'Performance',
            href: ADMIN_ROUTES.ADMIN_TRADING_PERFORMANCE,
            icon: BarChart3,
          },
          {
            name: 'Reports',
            href: ADMIN_ROUTES.ADMIN_TRADING_REPORTS,
            icon: FileText,
          },
          {
            name: 'Logs',
            href: ADMIN_ROUTES.ADMIN_AUDIT_LOGS,
            icon: History,
          },
        ],
      },
      {
        name: 'Risk Monitor',
        href: ADMIN_ROUTES.ADMIN_RISK_MONITORING,
        icon: Activity,
      },
      {
        name: 'Trade Monitor',
        href: ADMIN_ROUTES.ADMIN_TRADING_TRADE_HISTORY,
        icon: Monitor,
      },
      {
        name: 'Audit Logs',
        href: ADMIN_ROUTES.ADMIN_AUDIT_LOGS,
        icon: History,
      },
    ],
  },
];

export const MASTER_TRADER_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    href: USER_ROUTES.USER_MAM_DASHBOARD,
    icon: LayoutDashboard,
  },
  {
    name: 'My Group',
    href: USER_ROUTES.USER_MAM_GROUPS,
    icon: Building2,
  },
  {
    name: 'Followers',
    href: USER_ROUTES.USER_MAM_ACCOUNTS,
    icon: UserCheck,
  },
  {
    name: 'Allocation',
    href: USER_ROUTES.USER_MAM_ALLOCATION_RULES,
    icon: PieChart,
  },
  {
    name: 'Trades',
    href: USER_ROUTES.USER_MAM_TRADING_HISTORY,
    icon: Activity,
  },
  {
    name: 'Performance',
    href: USER_ROUTES.USER_TRADING_PERFORMANCE,
    icon: BarChart3,
  },
  {
    name: 'Statements',
    href: USER_ROUTES.USER_TRADING_STATEMENTS,
    icon: FileText,
  },
];

export const FOLLOWER_MAM_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    href: USER_ROUTES.USER_MAM_DASHBOARD,
    icon: LayoutDashboard,
  },
  {
    name: 'My Master',
    href: USER_ROUTES.USER_MAM_ACCOUNTS,
    icon: Users,
  },
  {
    name: 'My Trades',
    href: USER_ROUTES.USER_MAM_TRADING_HISTORY,
    icon: Activity,
  },
  {
    name: 'Performance',
    href: USER_ROUTES.USER_TRADING_PERFORMANCE,
    icon: BarChart3,
  },
  {
    name: 'Statements',
    href: USER_ROUTES.USER_TRADING_STATEMENTS,
    icon: FileText,
  },
];

export const SIGNAL_PROVIDER_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    href: USER_ROUTES.USER_COPY_TRADING_DASHBOARD,
    icon: LayoutDashboard,
  },
  {
    name: 'My Strategy',
    href: USER_ROUTES.USER_COPY_TRADING_MARKETPLACE,
    icon: LineChart,
  },
  {
    name: 'Subscribers',
    href: USER_ROUTES.USER_COPY_TRADING_ACTIVE,
    icon: UserCheck,
  },
  {
    name: 'Performance',
    href: USER_ROUTES.USER_TRADING_PERFORMANCE,
    icon: BarChart3,
  },
  {
    name: 'Revenue',
    href: USER_ROUTES.USER_TRADING_FEES,
    icon: CreditCard,
  },
  {
    name: 'Trades',
    href: USER_ROUTES.USER_COPY_TRADING_HISTORY,
    icon: Activity,
  },
  {
    name: 'Reviews',
    href: USER_ROUTES.USER_COPY_TRADING_PORTFOLIO,
    icon: FileText,
  },
  {
    name: 'Settings',
    href: USER_ROUTES.USER_COPY_TRADING_SETTINGS,
    icon: Settings,
  },
];

export const SUBSCRIBER_MENU: MenuItem[] = [
  {
    name: 'Marketplace',
    href: USER_ROUTES.USER_COPY_TRADING_MARKETPLACE,
    icon: LineChart,
  },
  {
    name: 'My Subscriptions',
    href: USER_ROUTES.USER_COPY_TRADING_ACTIVE,
    icon: Activity,
  },
  {
    name: 'My Trades',
    href: USER_ROUTES.USER_COPY_TRADING_HISTORY,
    icon: Activity,
  },
  {
    name: 'Performance',
    href: USER_ROUTES.USER_TRADING_PERFORMANCE,
    icon: BarChart3,
  },
  {
    name: 'Billing',
    href: USER_ROUTES.USER_TRADING_FEES,
    icon: CreditCard,
  },
  {
    name: 'Statements',
    href: USER_ROUTES.USER_TRADING_STATEMENTS,
    icon: FileText,
  },
  {
    name: 'Settings',
    href: USER_ROUTES.USER_COPY_TRADING_SETTINGS,
    icon: Settings,
  },
];
